import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { closeSnackbar, removeSnackbar } from '@store/reducers/snackbarSlice';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useEffect } from 'react';

const GlobalSnackbar: React.FC = () => {
  const { enqueueSnackbar, closeSnackbar: notistackCloseSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const snackbars = useAppSelector(state => state.snackbar);

  useEffect(() => {
    snackbars.forEach(snackbar => {
      if (!snackbar.displayed) {
        enqueueSnackbar(snackbar.message, {
          variant: snackbar.severity,
          key: snackbar.key,
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          style: { whiteSpace: 'pre-line' },
          onClose: () => dispatch(removeSnackbar(snackbar.key!)),
          action: (key) => (
            <IconButton size="small" color="inherit" onClick={() => notistackCloseSnackbar(key)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          ),
        });
        dispatch(closeSnackbar(snackbar.key!));
      }
    });
  }, [snackbars, enqueueSnackbar, dispatch, notistackCloseSnackbar]);

  return null;
};

const Provider = () => (
  <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
    <GlobalSnackbar />
  </SnackbarProvider>
);

export default Provider;
